import { render, staticRenderFns } from "./finalizacao.vue?vue&type=template&id=0e82ed6f&"
import script from "./finalizacao.vue?vue&type=script&lang=js&"
export * from "./finalizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports